import { jsx as o, Fragment as m, jsxs as l } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import "@storyblok/js";
import { getComponent as a, getEnableFallbackComponent as c, getCustomFallbackComponent as d } from "./state.mjs";
const s = i(
  ({ blok: e, ...t }, p) => {
    if (!e)
      return console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      ), /* @__PURE__ */ o("div", { children: "Please provide a blok property to the StoryblokComponent" });
    const n = a(e.component);
    if (n)
      return /* @__PURE__ */ o(n, { ref: p, blok: e, ...t });
    if (c()) {
      const r = d();
      return r ? /* @__PURE__ */ o(r, { blok: e, ...t }) : /* @__PURE__ */ o(m, { children: /* @__PURE__ */ l("p", { children: [
        "Component could not be found for blok",
        " ",
        /* @__PURE__ */ o("strong", { children: e.component }),
        "! Is it configured correctly?"
      ] }) });
    }
    return /* @__PURE__ */ o("div", {});
  }
);
s.displayName = "StoryblokComponent";
export {
  s as default
};
